import { Translate } from '@change-corgi/core/react/i18n';

import { ExportButton } from '../../shared/ExportButton';
import { useExportButton } from '../../shared/ExportButton/hooks/useExportButton';
import { ExportNotifications } from '../components/ExportNotifications';
import { PageBody } from '../components/PageBody/index_new';

export const Layout: React.FC<Props> = ({ setCommentsVisibility }) => {
	const { data, actions } = useExportButton('comments');

	return (
		<div
			className="bg-background-base relative flex max-h-[441px] min-h-fit w-full flex-col px-4 pt-8 md:p-12 md:pb-0"
			data-qa="starter-dashboard-comments-card-new"
			data-testid="starter-dashboard-comments-card-new"
			aria-label="export-comments-card-new"
			aria-describedby="export-comments-card-new"
		>
			{/* Header Section */}
			<div
				id="petition-comments-card-header"
				className="flex items-center justify-between gap-4 pb-[1px]"
				data-testid="comments-header-new"
			>
				<div data-testid="comments-title-container-new">
					<h3
						className="text-content-strong-color wrap-anywhere font-sans text-size-heading-xs font-bold md:text-size-heading-small"
						id="comments-card-header-new"
						data-qa="comments-card-header-heading-new"
						data-testid="comments-card-header-heading-new"
						aria-label="export-comments-header-heading-new"
						aria-describedby="export-comments-header-heading-new"
					>
						<Translate value="corgi.petition.starter_dashboard.petition_comments.card.header" />
					</h3>
				</div>
				<div className="ml-auto justify-self-end" data-testid="comments-export-container-new">
					<ExportButton
						data-qa="export-signatures-button-new"
						aria-label="export-comments-button-new"
						aria-describedby="export-comments-button-new"
						exportType="COMMENTS"
						data={data}
						actions={actions}
						data-testid="export-comments-button-new"
					/>
				</div>
			</div>

			{/* Comments Body */}
			<div data-testid="comments-body-new">
				<PageBody setCommentsVisibility={setCommentsVisibility} />
			</div>
			<ExportNotifications data={data} data-testid="comments-export-notifications-new" />
		</div>
	);
};

type Props = Readonly<{
	setCommentsVisibility: (visible: boolean) => void;
}>;
